import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterProductGimmickEditPage } from './master-product-gimmick-edit.page';

const routes: Routes = [
  {
    path: '',
    component: MasterProductGimmickEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterProductGimmickEditPageRoutingModule {}
